import React from "react";

const Features = ({ translations }) => {
  if (!translations || !translations.features) {
    return <p>Loading...</p>;
  }

  return (
    <section id="features" className="section features">
      <div className="container">
        <h2>{translations.featuresTitle}</h2>
        <div className="feature-list">
          {translations.features.map((feature, index) => (
            <div key={index} className="feature">
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;